import {
  FeedbackSource,
  FeedbackStatus
} from "../../interfaces/endpoints/ICustomerFeedback";

export const SOURCE_LABELS: Record<FeedbackSource, string> = {
  [FeedbackSource.ReportLine]: "Raporto linjën",
  [FeedbackSource.ResultsFeedback]: "Reagime për rezultatet",
  [FeedbackSource.NotifyNoResults]: "Njofto · Pa rezultate",
  [FeedbackSource.NotifyFewResults]: "Njofto · Pak rezultate"
};

export const SOURCE_BADGE_CLASSES: Record<FeedbackSource, string> = {
  [FeedbackSource.ReportLine]: "bg-red-100 text-red-700",
  [FeedbackSource.ResultsFeedback]: "bg-amber-100 text-amber-700",
  [FeedbackSource.NotifyNoResults]: "bg-blue-100 text-blue-700",
  [FeedbackSource.NotifyFewResults]: "bg-indigo-100 text-indigo-700"
};

export const STATUS_LABELS: Record<FeedbackStatus, string> = {
  [FeedbackStatus.New]: "I ri",
  [FeedbackStatus.Reviewed]: "I shqyrtuar",
  [FeedbackStatus.Actioned]: "I përfunduar"
};

export const STATUS_BADGE_CLASSES: Record<FeedbackStatus, string> = {
  [FeedbackStatus.New]: "bg-orange-100 text-orange-700",
  [FeedbackStatus.Reviewed]: "bg-gray-100 text-gray-700",
  [FeedbackStatus.Actioned]: "bg-green-100 text-green-700"
};

export const SOURCE_OPTIONS: Array<{ value: FeedbackSource; label: string }> = [
  { value: FeedbackSource.ReportLine, label: SOURCE_LABELS[FeedbackSource.ReportLine] },
  {
    value: FeedbackSource.ResultsFeedback,
    label: SOURCE_LABELS[FeedbackSource.ResultsFeedback]
  },
  {
    value: FeedbackSource.NotifyNoResults,
    label: SOURCE_LABELS[FeedbackSource.NotifyNoResults]
  },
  {
    value: FeedbackSource.NotifyFewResults,
    label: SOURCE_LABELS[FeedbackSource.NotifyFewResults]
  }
];

export const STATUS_OPTIONS: Array<{ value: FeedbackStatus; label: string }> = [
  { value: FeedbackStatus.New, label: STATUS_LABELS[FeedbackStatus.New] },
  { value: FeedbackStatus.Reviewed, label: STATUS_LABELS[FeedbackStatus.Reviewed] },
  { value: FeedbackStatus.Actioned, label: STATUS_LABELS[FeedbackStatus.Actioned] }
];
export const formatRouteName = (raw: string | null | undefined): string =>
  (raw ?? "").split(",")[0].trim();
